module.exports = __webpack_public_path__ + "static/img/title_id.d13e4721.png";